import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { CSSProperties } from 'react';
import { CampusHeader } from '../Components/CampusHeader';
import { CampusFooter } from '../Components/CampusFooter';

const Or: CSSProperties = {
    letterSpacing: 'normal',
    paddingTop: '16px',
    paddingBottom: '16px',
    textAlign: 'center'
}
const href: CSSProperties = {
    textDecoration: 'underline'
}
const itemStyle: CSSProperties = {
    fontSize: '13px',
    padding: '5px',
    margin: '5px 10px',
    letterSpacing: '2px',
    borderBottom: '1px solid rgba(87,144,161,0.2)',
    fontFamily: 'BarlowLight',
    color: '#616060'
}
const questionStyle: CSSProperties = {
    fontFamily: 'Lulo',
    fontSize: '15px',
    letterSpacing: 'normal',
    color: '#616060',
    display: 'flex',
    cursor: 'pointer'
}

class QAProps extends Tgcc.BaseProps {
    question: any;
    answer: any;
    handleChange: (i) => void;
    currentIndex: any;
    index: any;
}
const questionDiv: CSSProperties = {
    minHeight: '50px'
}
const carrot: CSSProperties = {
    height: '19px',
    width: '15px'
}

const openLicense = () => { browserHistory.push(Tgcc.Routes.OtherSchools) }

class _CampusQA extends React.Component<QAProps, any>{

    render() {
        var current = this.props.currentIndex === this.props.index;
        return (
            <div style={questionDiv}>
                <div style={questionStyle} onClick={() => this.props.handleChange(this.props.index)}>{this.props.question}{current ? <span style={carrot}>&#9650;</span> : <span style={carrot}>&#9660;</span>}</div>
                {this.props.currentIndex === this.props.index ? <div style={itemStyle}>{this.props.answer}</div> : <div style={itemStyle}></div>}
            </div>
        )
    }
}
const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return {
        state: state
    }
};
export var CampusQA = connect(mapStateToProps)(_CampusQA)